const selectBackgroundColor = (theme) =>
  theme?.palette?.background?.color || 'white';
const selectTypographyColor = (theme) => theme.typography.color;

export { selectBackgroundColor, selectTypographyColor };
